import * as React from "react";
import { InputProps } from "../../types/InputProps";

import TextField from "@material-ui/core/TextField";

class InputPassword extends React.Component<InputProps> {

    public render() {
        return (
            <TextField
                disabled={this.props.disabled}
                type="password"
                label={this.props.label ? this.props.label : null}
                placeholder={this.props.placeholder ? this.props.placeholder : null}
                value={this.props.value ? this.props.value : ""}
                error={this.props.error ? this.props.error : false}
                style={{ width: "100%" }}
                helperText={this.props.legend ? this.props.legend : ""}
                onChange={(event) => this.props.onChange(event.target.value, event.target)}
                required={this.props.required}
                inputProps={{
                    onInput: (event) => this.props.onInput ? this.props.onInput(event.target.value, event.target) : null
                }}
            />
        );
    }

}

export default InputPassword;


// WEBPACK FOOTER //
// ./src/components/InputPassword/InputPassword.tsx